/***
 * Created on 2023/7/7
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import logo from '../../static/img/header/acc-logo.svg';
import AccountHeader from "./account_header";
import ServiceHeader from "./service_header/service_header";
import SupportHeader from "./support_header";
import SettingsHeader from "./settings_header";
import {useLanguage} from "../../hook/hooks";
import {getCurrentDomainRegion, CHINA} from "../../service/common";

const Header = () => {
    useLanguage();

    const clickOnLogo = () => {
        window.location.hash = '';
        const uri = location.href;
        if (location.href.endsWith('#')) {
           const clean_uri = uri.substring(0, uri.indexOf("#"));
           window.history.replaceState({}, document.title, clean_uri);
        }
        window.location.pathname = '/';
    }

    return (
        <>
            <div className="utils" data-qnap-services>
                <ServiceHeader/>
            </div>
            <div className="app-name" data-location={getCurrentDomainRegion() === CHINA ? 'cn' : logo}  onClick={clickOnLogo}>
                <div className="logo"></div>
                <div className="name">QNAP Account</div>
                <div className="badge">.CN</div>
            </div>
            <div className="utils">
                {/*<ServiceHeader />*/}
                <SettingsHeader/>
                <SupportHeader/>
                {/*<div className="divide" />*/}
                <AccountHeader/>
            </div>
        </>
        // </header>
    );
};

export default Header;